
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Admin extends Vue {
  get isAdmin(): boolean {
    return this.$store.state.user.uid == "EhJwGIUSFzOdVMvpoNigKgdc91n1";
  }
}
